// extracted by mini-css-extract-plugin
export var quoteColumn = "index-module--quoteColumn--6sm-K";
export var quoteColumnContainer = "index-module--quoteColumnContainer--q0Esc";
export var quoteDark = "index-module--quoteDark--DsYSv";
export var quoteHeadingContainer = "index-module--quoteHeadingContainer--jYjzP";
export var quoteImageContainer = "index-module--quoteImageContainer--xpwF1";
export var quoteInnerContainer = "index-module--quoteInnerContainer--tTZZ0";
export var quoteOuterContainer = "index-module--quoteOuterContainer--T1V3M";
export var quoteTextContainer = "index-module--quoteTextContainer--oC2zb";